<template>
	<div>
		<el-card class="box-card">
			<el-form :inline="true">
				<el-form-item label="名称">
					<el-input placeholder="请填写" v-model="listQuery.search.name" clearable> </el-input>
				</el-form-item>
				<el-button type="success" @click="handleCreate">添加分组</el-button>
			</el-form>
			<el-button type="primary" @click="keySearch"><i class="el-icon-search"></i> 搜索</el-button>
			<el-button type="primary" style="margin-left:30px;" plain @click="resetSearch"><i
					class="el-icon-search"></i>
				重置搜索</el-button>
		</el-card>
		<div style="margin-top:30px">
			<el-table v-loading="loading" :data="data_list" stripe style="width: 100%" size="small">
				<el-table-column prop="country_init" label="国家"></el-table-column>
				<el-table-column prop="name" label="名称"></el-table-column>
				<el-table-column prop="create_time" label="添加时间"></el-table-column>
				<el-table-column label="操作" fixed="right" with="250">
					<template slot-scope="{row,$index}">
						<el-button type="primary" size="mini" @click="handleUpdate(row)">编辑</el-button>
						<el-popconfirm @confirm="handleDelete(row,$index)" @onConfirm="handleDelete(row,$index)"
							title="确定删除该数据？">
							<el-button style="margin-left:10px;" type="danger" size="mini" slot="reference">删除
							</el-button>
						</el-popconfirm>
					</template>
				</el-table-column>
			</el-table>
			<pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.row"
				@pagination="getList" />
			<!-- 添加分组 -->
			<el-dialog title="添加分组" width="40%" :visible.sync="is_show_create">
				<span>
					<el-form ref="form" label-width="120px" size="medium">
						<el-form-item label="国家">
							<el-col :span="12">
								<el-select v-model="create_data.country" clearable placeholder="请选择">
									<el-option v-for="item in country_list" :key="item.value" :label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
							</el-col>
						</el-form-item>
						<el-form-item label="分组名称">
							<el-col :span="12">
								<el-input placeholder="请填写" v-model="create_data.name" clearable> </el-input>
								</el-input>
							</el-col>
						</el-form-item>
					</el-form>
				</span>
				<span slot="footer" class="dialog-footer">
					<el-button @click="is_show_create = false">返回</el-button>
					<el-button :loading="this.$store.state.ajaxLoading" type="primary" @click="createData()">确定</el-button>
				</span>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	import {
		groupAdd,
		groupList,
		groupDel
	} from '@/api/sign_shop'
	import request from '@/tool/request'
	import {
		parseTime,alertMsg
	} from '@/tool/index'
	import Qs from 'qs'
	import Pagination from '@/components/Pagination' // 基于分页的二级包装
	export default {
		components: {
			Pagination,
		},
		data() {
			return {
				total: 0, // 总条数
				listQuery: null,
				data_list: [], // 表格数据
				loading: true,
				is_show_create: false,
				create_data: {},
				country_list:[],
			};
		},
		filters: {
			parseTime,
		},
		created() {
			this.resetSearchData()
			this.getList()
		},
		methods: {
			keySearch() { // 搜索
				this.listQuery.page = 1
				this.getList()
			},
			resetSearch() { // 重置搜索
				this.resetSearchData()
				this.getList()
			},
			resetSearchData() { // 重置listQuery搜索数据
				this.listQuery = {
					page: 1,
					row: 10,
					search: {
						name: '',
					},
				}
			},
			getList() { // 获取列表数据
				this.loading = true;
				groupList(Qs.stringify(this.listQuery)).then(response => {
					let r = response.result;
					this.data_list = r.items;
					this.total = r.total;
					
					if(r.country_list){
						this.country_list = r.country_list;
					}
					this.loading = false;
				})
			},
			handleDelete(row, index) {
				groupDel(Qs.stringify(row)).then(response => {
					this.data_list.splice(index, 1);
					alertMsg(this,'删除成功','success');
				})
			},
			resetCreateData() { // 重置create_data数据
				this.create_data = {
					id:'',
					name:'',
					country:'',
				}
			},
			handleCreate() {
				this.resetCreateData();
				this.is_show_create = !this.is_show_create;
			},
			createData() {
				this.$store.commit('setAjaxLoading', true);
				groupAdd(Qs.stringify(this.create_data)).then(response => {
					this.getList();
					this.is_show_create = !this.is_show_create;
					alertMsg(this,'提交成功','success');
				})
			},
			// 编辑
			handleUpdate(row) {
				this.create_data = Object.assign({}, row) // copy obj
				this.is_show_create = !this.is_show_create;
			},
		}
	}
</script>
